import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Header, Content, ContentsWrapper } from '../../../common/ModalBlocks';
import EducationIcon from './Education.svg';
import { DEGREE_TITLES } from './consts';

import classes from './index.module.scss';

const T_KEY = 'freelancer_page.modal.education';

/** @type {import('./index').Educations} */
export const Educations = ({ educations = [] }) => (
    <div className={classes.wrapper}>
        <Header title={<I18n k={`${T_KEY}.title`} />} />
        <ContentsWrapper>
            {educations.map((education) => (
                <Content
                    subtitleClassName={classes.subtitle}
                    icon={<img src={EducationIcon} />}
                    key={`${education.degree}${education.toYear}${education.school}`}
                    title={education.school}
                    subtitle={
                        <>
                            {DEGREE_TITLES[education.degreeTitle]} <I18n k={`${T_KEY}.degree`} /> {education.degree}
                        </>
                    }
                    description={
                        <>
                            <I18n k={`${T_KEY}.graduated`} /> {education.toYear}
                        </>
                    }
                />
            ))}
        </ContentsWrapper>
    </div>
);
